import ModalClose from '@mui/icons-material/CloseRounded';
import MenuIcon from '@mui/icons-material/Menu';
import Box from '@mui/material/Box';
import DialogTitle from '@mui/material/DialogTitle';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { FilterMatchMode } from 'primereact/api';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Tag } from 'primereact/tag';
import React, { useEffect, useState } from 'react';
import { supportColumns } from '../../../assets/const/Constant';
import { ApiData } from '../../../data/apiData';
import BootstrapDateRangePicker from '../../date/BootstrapDateRangePicker';
import Filter from '../../filter/Filter.js';
import AddTicket from '../support/AddTicket';
import TicketDetails from './TicketDetails';
import moment from 'moment/moment.js';
import PaginatorTemplate from '../../PanginatorTemplate.js';
import { useSelector } from 'react-redux';
import { useApi } from '../../../assets/helper/ApiHandler.js';

export default function Support() {
    const [dates, setDates] = useState({
        startDate: moment(),
        endDate: moment()
    });
    const [componentToRender, setComponentToRender] = useState(null);
    const [supportData, setSupportData] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [rowClick, setRowClick] = useState(false);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [filters, setFilters] = useState({ global: { value: null, matchMode: FilterMatchMode.CONTAINS }, });
    const [state, setState] = React.useState({ right: false, });
    const [rows, setRows] = useState(10);
    const [currentPage, setCurrentPage] = useState(0);
    const totalRecords = useSelector(state => state.totalRecords.count);
    const { getUseRequest } = useApi();

    useEffect(() => {
        ApiData.getSupport().then(data => setSupportData(data));
    }, []);

    const toggleDrawer = (anchor, open, component) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setComponentToRender(component);
        setState({ ...state, [anchor]: open });
    };


    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const handleSelectedDate = (dates) => {
        setDates(dates);
    }

    const renderHeader = () => {
        return (
            <div className="flex justify-content-end" style={{ display: 'flex', justifyContent: 'end' }}>
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search" />
                </span>
                <span className="p-input-icon-left">
                    <i className="pi pi-calendar" />
                    <BootstrapDateRangePicker
                        dates={dates}
                        selectedDate={handleSelectedDate}
                    />
                </span>
                <span className="p-input-icon-left">
                    <i className="pi pi-filter" />
                    {/* <InputText placeholder="Filter" /> */}
                    <Filter
                        columnsList={supportColumns}
                    />
                </span>
            </div>
        );
    };



    const handleOnRowsChange = (newRows) => {
        setRows(newRows.value);
        setCurrentPage(0);
    };

    const handleOnPageChange = (page) => {
        setCurrentPage(page);
    }

    const getSeverity = (status) => {
        switch (status) {
            case 'Open':
                return 'warning';
            case 'Pending':
                return 'info';
            case 'Closed':
                return 'sucess';
        }
    };
    const statusBodyTemplate = (rowData) => {
        return <Tag value={rowData.status} severity={getSeverity(rowData.status)} className={getSeverity(rowData.status) === 'sucess' ? 'status status-closed' : '' || getSeverity(rowData.status) === 'info' ? 'status status-pending' : '' || getSeverity(rowData.status) === 'warning' ? 'status status-open' : ''} />;
    };
    const supportTitle = () => {
        return (
            <div>
                {['right'].map((anchor) => (
                    <div
                        className="supplyPartner flex justify-content-left"
                        key={anchor}
                        onClick={toggleDrawer(anchor, true, 'TicketDetails')}
                    >
                        Can't add new supply
                    </div>
                ))}
            </div>
        );
    };

    return (
        <div className="card">
            <Toolbar className='main-content-header'>
                <Typography variant="h6" noWrap component="div">
                    <h2>Support</h2>
                </Typography>
                {/*<Link to='/addticket'><Button type="button" icon="pi pi-plus" className="button-style-1" label="Add ticket" size="small"></Button></Link> */}
                {['right'].map((anchor) => (<Button type="button" key={anchor} onClick={toggleDrawer(anchor, true, 'AddTicket')} icon="pi pi-plus" className="button-style-1" label="Add ticket" size="small"></Button>))}

                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    edge="start"
                    sx={{ mr: 2, display: { sm: 'none' } }}>
                    <MenuIcon />
                </IconButton>
            </Toolbar>
            <DataTable value={supportData}
                filters={filters}
                className='support-data-table'
                header={renderHeader()}
                emptyMessage="No customers found."
                selectionMode={rowClick ? null : 'checkbox'}
                selection={selectedProducts}
                onSelectionChange={(e) => setSelectedProducts(e.value)}
                dataKey="id"
                paginator rows={10}
                paginatorTemplate={
                    PaginatorTemplate({
                        currentPage,
                        totalRecords,
                        rows,
                        handleOnRowsChange,
                        handleOnPageChange,
                    })}
                tableStyle={{ minWidth: '50rem' }} resizableColumns>
                <Column field="ticketId" header="Ticket ID" filterPlaceholder="Search by name"></Column>
                <Column field="ticketTitle" header="Ticket Title" headerStyle={{ textAlign: 'left' }} alignHeader={'left'} body={supportTitle} ></Column>
                <Column field="dateCreated" header="Date Created" headerStyle={{ textAlign: 'center' }} alignHeader={'center'} bodyStyle={{ textAlign: 'center' }}></Column>
                <Column field="priority" header="Priority" headerStyle={{ textAlign: 'center' }} alignHeader={'center'} bodyStyle={{ textAlign: 'center' }}></Column>
                <Column field="status" header="Status" style={{ minWidth: '12rem' }} body={statusBodyTemplate} headerStyle={{ textAlign: 'center' }} alignHeader={'center'} bodyStyle={{ textAlign: 'center' }}></Column>
            </DataTable>

            {['right'].map((anchor) => (
                <Drawer key={anchor}
                    anchor={anchor}
                    className='drawer-panel'
                    open={state[anchor]}
                    onClose={toggleDrawer(anchor, false)}>
                    {componentToRender === 'AddTicket' &&
                        <Box className='drawerHeader'>
                            <DialogTitle >Create a new ticket</DialogTitle>
                            <ModalClose className='drawerClose' onClick={toggleDrawer(anchor, false)} />
                        </Box>}
                    {componentToRender === 'AddTicket' && <AddTicket />}

                    {componentToRender === 'TicketDetails' &&
                        <Box className='drawerHeader'>
                            <DialogTitle >Can't add new supply</DialogTitle>
                            <ModalClose className='drawerClose' onClick={toggleDrawer(anchor, false)} />
                        </Box>}
                    {componentToRender === 'TicketDetails' && <TicketDetails />}
                </Drawer>
            ))}
        </div>

    )
}
